export default __webpack_public_path__ + "static/media/banana.d3e22b5b.png";